import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

import './navbar.scss';

import Icon from './images/small-icon.png';
import About from './images/info.png';
import AboutSelected from './images/info-selected.png';
import Login from './images/login.png';
import LoginSelected from './images/login-selected.png';
import Profile from './images/user.png';
import ProfileSelected from './images/user-selected.png';
import ArrowRight from './images/arrow-right.png';

import MobileMenu from './images/mobile-menu.png';



import Placeholder from './images/placeholder-profile.svg';

import { useUser } from './hooks/useUser';


const NavBar = ({ completedTestExists }) => {

  const { user } = useUser();
  const [aboutHovered, setAboutHovered] = useState(false);
  const [profileHovered, setProfileHovered] = useState(false);
  const [loginHovered, setLoginHovered] = useState(false);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const desktopNav = () => {

    return (<> {user == null ?
      <NavLink
        to='profile'
        className="nav-link desktop"
        onMouseEnter={() => setLoginHovered(true)}
        onMouseLeave={() => setLoginHovered(false)}
      >

        {({ isActive }) => (

          <div className="normal-flex-divider vertical-center">
            <div className="nav-icon-container">
              <img className="nav-icon" src={isActive || loginHovered ? LoginSelected : Login} alt="small-icon" />
            </div>
            <div className="nav-text">
              Log in / Register
            </div>
          </div>

        )}
      </NavLink>

      :

      <NavLink
        to='profile'
        className="nav-link desktop"
        onMouseEnter={() => setProfileHovered(true)}
        onMouseLeave={() => setProfileHovered(false)}
      >
        {({ isActive }) => (
          <div className="normal-flex-divider vertical-center">
            <div className="nav-icon-container">
              <img className="nav-icon" src={isActive || profileHovered ? ProfileSelected : Profile} alt="small-icon" />
            </div>
            <div className="nav-text"> Profile </div>
          </div>
        )}
      </NavLink>
    }

      {
        completedTestExists ?
          <NavLink to='results'
            className="nav-link desktop">
            {({ isActive }) => (

              <div className="normal-flex-divider vertical-center">
                <div className="nav-icon-container">
                  <img className="nav-icon" src={isActive ? Placeholder : Placeholder} alt="small-icon" />
                </div>
                <div className="nav-text">
                  My Results
                </div>
              </div>

            )}
          </NavLink>

          :

          <NavLink to='pre-test' className="nav-link desktop">

            <button className="button special reverse">
              <div className="nav-icon-container">
                <img className="nav-icon" src={ArrowRight} alt="small-icon" />
              </div>
              <div className="nav-text">
                Take the test
              </div>
            </button>

          </NavLink>

      } </>);

  }

  const mobileMenu = () => {


    return (
      <div className={`mobile-menu ${mobileMenuOpen ? ' open' : ''}`}>
        <div className="modal-menu-container">
          <span className="close" onClick={() => { setMobileMenuOpen(false) }}>&times;</span>

          <div className="mobile-menu-body">

            <NavLink to='/' className="nav-homepage" onClick={() => { setMobileMenuOpen(false) }}>
              <div >
                <div className="normal-flex-divider vertical-center">
                  <div className="nav-icon-container">
                    <img className="nav-icon" src={Icon} alt="small-icon" />
                  </div>
                  <div className="nav-text">
                    Home
                  </div>
                </div>
              </div>

            </NavLink>

            <NavLink to='/about' className="nav-homepage" onClick={() => { setMobileMenuOpen(false) }}>

              {({ isActive }) => (

                <div >
                  <div className="normal-flex-divider vertical-center">
                    <div className="nav-icon-container">
                      <img className="nav-icon" src={isActive ? AboutSelected : About} alt="small-icon" />
                    </div>
                    <div className="nav-text">
                      About
                    </div>
                  </div>
                </div>

              )}
            </NavLink>


            {user == null ?

              <NavLink
                to='profile'
                className="nav-homepage"
                onClick={() => { setMobileMenuOpen(false) }}
              >

                {({ isActive }) => (


                  <div className="normal-flex-divider vertical-center">
                    <div className="nav-icon-container">
                      <img className="nav-icon" src={isActive ? LoginSelected : Login} alt="small-icon" />
                    </div>
                    <div className="nav-text">
                      Log in / Register
                    </div>
                  </div>

                )}

              </NavLink>

              :

              <NavLink
                to='/profile'
                className="nav-homepage"
                onClick={() => { setMobileMenuOpen(false) }}
              >

                {({ isActive }) => (


                  <div className="normal-flex-divider vertical-center">
                    <div className="nav-icon-container">
                      <img className="nav-icon" src={isActive ? ProfileSelected : Profile} alt="small-icon" />
                    </div>
                    <div className="nav-text"> Profile </div>
                  </div>

                  )}

              </NavLink>
                                
            }


            {
              completedTestExists ?

                <NavLink to='/results'
                  className="nav-homepage"
                  onClick={() => { setMobileMenuOpen(false) }}
                >
                  <div >
                    <div className="normal-flex-divider vertical-center">
                      <div className="nav-icon-container">
                        <img className="nav-icon" src={Placeholder} alt="small-icon" />
                      </div>
                      <div className="nav-text">
                        My Results
                      </div>
                    </div>
                  </div>
                </NavLink>

                :


                <NavLink to='pre-test'
                  className="nav-link"
                  onClick={() => { setMobileMenuOpen(false) }}
                >

                  <div >
                    <button className="button special reverse">
                      <div className="nav-icon-container">
                        <img className="nav-icon" src={ArrowRight} alt="small-icon" />
                      </div>
                      <div className="nav-text">
                        Take the test
                      </div>
                    </button>
                  </div>

                </NavLink>

            }


          </div>
        </div>
      </div>
    );




  }

  const mobileNav = () => {

    return (<>
      {mobileMenu()}
      <div className="mobile-menu-toggle">
        <div className="nav-icon-container">
          <img className="nav-icon" src={MobileMenu} alt="small-icon" onClick={() => {
            setMobileMenuOpen(true);
          }} />
        </div>
      </div>
    </>);

  }



  return (
    <nav>
      <div className="nav">
        <div className="nav-left">
          <NavLink to='/' className="nav-homepage">
            <div >
              <div className="normal-flex-divider vertical-center">
                <div className="nav-icon-container">
                  <img className="nav-icon" src={Icon} alt="small-icon" />
                </div>
                <div className="nav-text">
                  The Big Five
                </div>
              </div>
            </div>
          </NavLink>


          <NavLink
            to='about'
            className="nav-link desktop"
            onMouseEnter={() => setAboutHovered(true)}
            onMouseLeave={() => setAboutHovered(false)}
          >

            {({ isActive }) => (

              <div >
                <div className="normal-flex-divider vertical-center">
                  <div className="nav-icon-container">
                    <img className="nav-icon" src={isActive || aboutHovered ? AboutSelected : About} alt="small-icon" />
                  </div>
                  <div className="nav-text">
                    About
                  </div>
                </div>
              </div>

            )}

          </NavLink>

        </div>

        <div className="nav-right">

          {desktopNav()}
          {mobileNav()}

        </div>
      </div>
    </nav>
  );

}

export default NavBar;
